module.exports = __webpack_public_path__ + "static/media/resource.d441764f.svg";